<app-estado-resp-exitoso [response]="respuestaRetiro"
                         *ngIf="respuestaRetiro?.exitoso === true"></app-estado-resp-exitoso>
<app-estado-resp-error *ngIf="respuestaRetiro?.exitoso === false"></app-estado-resp-error>
<div class="mg-top-25" *ngIf="respuestaRetiro?.exitoso === undefined || respuestaRetiro?.exitoso === null">
  <p>
    A continuación selecciona el estado civil (al cuál deseas cambiar a tu
    empleado)
  </p>
</div>
<form
  class="d-flex seleccionar-nuevo-estado mg-top-30"
  [formGroup]="form"
  (ngSubmit)="mostrarDialogoSubmit()"
  *ngIf="respuestaRetiro?.exitoso === undefined || respuestaRetiro?.exitoso === null"
>
  <div class="d-flex seleccion-tipo-cambio">
    <label for="estadoCivil" class="u-bold">Nuevo estado civil</label>
    <div>
      <select formControlName="estadoCivil" id="estadoCivil">
        <option value="" selected disabled>Seleccione</option>
        <option *ngFor="let estado of estados" [ngValue]="estado">
          {{ estado.desc }}
        </option>
      </select>
      <div class="text-invalid">
        <app-form-errors
          *ngIf="form?.get('estadoCivil')?.touched"
          [errors]="form?.get('estadoCivil')?.errors"
        >
          Campo obligatorio
        </app-form-errors>
      </div>
    </div>
  </div>
  <button
    type="button"
    (click)="mostrarDialogo()"
    appDebounceClick
    title="Cambiar"
    class="u-btn u-btn--blue"
    [disabled]="deshabilitarCambioEstadoCivil"
  >
    <!-- <em aria-hidden="true" class="material-icons">keyboard_arrow_right</em> -->

    Cambiar
  </button>
  <div class="col-md-12">
    <!-- Componente de Informacion Conyugue -->
    <app-exponer-informacion
      *ngIf="tieneEstadoCivil"
      [form]="form"
      [datosAfiliado]="datosAfiliado"
      [estadoCivilSeleccionado]="tieneEstadoCivil"
      (eventoHijo)="recibirFuncionRegresar()"
      [habilitarConyugeCuidador]="habilitarConyugeCuidador"
      (eventoValidar)="checkAndValidate()"
    >
      <div
        class="steps-cont_actions d-flex d-flex--nowrap mg-btm-20 justify-content-end"
      >
        <button
          type="button"
          [disabled]="deshabilitarBtnBuscarPersona  || this.documentosListos"
          (click)="validarConyuge(form,'conyuge')"
          class="u-btn u-btn--blue"
        >
          Buscar
        </button>
      </div>

      <app-build-form-request
        *ngIf="documentosListos"
        [idRequestType]="idRequestType"
        [form]="form"
        [dataJson]="dataJsonBuilForm"
      >
      </app-build-form-request>

      <div class="steps-cont_actions d-flex justify-content-center container">
        <button
          class="u-btn u-btn--line r-hide"
          type="button"
          (click)="recibirFuncionRegresar()"
          title="Regresar"
        >
          Regresar
        </button>
        <button
          type="submit"
          [disabled]="form.invalid || !this.documentosListos"
          id="solicitudEstadoCivil"
          title="Enviar"
          class="u-btn u-btn--blue"
        >
          Enviar
        </button>

      </div>
    </app-exponer-informacion>
  </div>
</form>

<app-modal-processing
  [title]="'Enviando datos'"
  [idModal]="idModalLoad"
  [textDescription]="
    'Estamos enviando los datos. No cierre la página hasta que termine, esto puede tardar unos segundos.'
  "
>
</app-modal-processing>

<app-modal
  [title]="'Cerrar'"
  [idModal]="'info'"
  [textDescription]="
    'No se puede realizar el proceso de cambio de estado civil porque ya tiene una solicitud en proceso'
  "
>
</app-modal>
